import CommandesTable from '../../components/organisms/CommandeTable';
import React from 'react';
import { MY_ID } from '../../helpers/user/authorization';
import { useToCommandePages } from '../../hooks/useToCommandePages';

const MesCommandes = () => {
  const [toCommandeSinglePage, toCommandeUpdatePage] = useToCommandePages();

  return (
    <CommandesTable
      userID={MY_ID}
      toCommandeSinglePage={toCommandeSinglePage}
      toCommandeUpdatePage={toCommandeUpdatePage}
    />
  );
};
export default MesCommandes;
